import { Box, Button, Container, DialogTitle, ListItem, Tab, Tabs, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Colors } from "../theme";

export const StyledContainer = styled(Container)(({ theme }) => ({
  marginTop: "2rem",
  // Targeting the .reopen-button class inside the StyledContainer
  "& .reopen-button": {
    backgroundColor: Colors.primary, // Set background color
    color: Colors.white, // Set text color
    "&:hover": {
      backgroundColor: Colors.hover, // Optional: darken color on hover
    },
  },

  '& .dialogTitle': {
    backgroundColor: Colors.primary,
    color: Colors.white,
    textAlign: "center",
    fontWeight: "600",
    margin: 0, /* Remove default margin */
    padding: "0.5rem", /* Reduce padding for a compact look */
    lineHeight: 1.4,
    marginBottom: "1rem", /* Add spacing below the title */
  }

}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: Colors.primary,
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: "1rem",
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: "600",
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: "1px solid "+Colors.border,
  paddingBottom: "1rem",
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "0.5rem",
  padding: 0,
  textDecoration: "underline",
  fontSize: "14px",
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  flex: 1,
}));

export const ModalTypography = styled(Typography)(({ theme }) => ({
  marginBottom: "0.5rem",
}));

export const ReopenButton = styled(Button)(({ theme }) => ({
  backgroundColor: Colors.primary, // Set the button background color
  color: Colors.white, // Set the text color
  "&:hover": {
    backgroundColor: Colors.hover, // Darken the color on hover
  },
}));
export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: Colors.primary,
  color: Colors.white,
  textAlign: "center",
  fontWeight: "600",
  margin: 0,
  padding: "0.5rem",
  lineHeight: 1.4,
  marginBottom: "1rem",
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  backgroundColor: Colors.primary, // Set the button background color
  color: Colors.white, // Set the text color
  "&:hover": {
    backgroundColor: Colors.hover, // Darken the color on hover
  },
}));


